import { useEffect, useState } from "react"
import { useAppDispatch, useAppSelector } from "@/core/app/hooks"
import { RootState } from "@/core/app/store"
import { UDTabs } from "../custom/UDTabs"
import { UDSetupType } from "./UDSetupType"
import { UDSetupTooth } from "./UDSetupTooth"
import { UDSetupArchform } from "./UDSetupArchform"
import {
  EArchType,
  gdsPlusSetup,
  toothMovement,
  viewControlInTreatment,
  wasmModule,
} from "@/gluelayer"
import { setLockCaseForEdit, setOpenBiteCheck } from "../udTreatSlice"
import { RightPage } from "../right/RightPage"
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Stack,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material"

export const UDSetup = (props) => {
  const dispatch = useAppDispatch()
  const { curArch, openBiteCheck } = useAppSelector(
    (state: RootState) => state.udTreatService,
  )

  const [fastsmartAlert, setFastsmartAlert] = useState(false)
  const [alignment, setAlignment] = useState(null)

  useEffect(() => {
    return () => {
      setAlignment(null)
      toothMovement.switchModuleFineTuneCircle(false)
      toothMovement.switchModuleFastSmartCircle(false)
    }
  }, [])

  const handleAlignment = (e, nextTool: string) => {
    if (nextTool === "fastsmart" || nextTool === "finetune") {
      if (nextTool === alignment) {
        setAlignment(null)
        toothMovement.switchModuleFineTuneCircle(false)
        toothMovement.switchModuleFastSmartCircle(false)
        return
      }

      const hasUpper = wasmModule.getArchModel(EArchType.UpArch)
      const hasLower = wasmModule.getArchModel(EArchType.LowArch)

      if (hasUpper && hasLower && curArch === "all") {
        setFastsmartAlert(true)
        return
      }
    }
    if (!wasmModule.isFinishedOpencase) return

    if (nextTool === "fastsmart") {
      if (openBiteCheck) {
        dispatch(setOpenBiteCheck(false))
        viewControlInTreatment.setOcclusionVisibility(false)
      }

      toothMovement.switchModuleFineTuneCircle(false)
      toothMovement.switchModuleFastSmartCircle(true)
    } else if (nextTool === "finetune") {
      if (openBiteCheck) {
        dispatch(setOpenBiteCheck(false))
        viewControlInTreatment.setOcclusionVisibility(false)
      }
      viewControlInTreatment.setOcclusionVisibility(false)
      toothMovement.switchModuleFastSmartCircle(false)
      toothMovement.switchModuleFineTuneCircle(true)
    } else {
      toothMovement.switchModuleFineTuneCircle(false)
      toothMovement.switchModuleFastSmartCircle(false)
    }

    setAlignment(nextTool)
  }

  return (
    <RightPage
      title="Setup"
      onClose={props.onClose}
      content={
        <>
          <Stack direction="row" spacing={2} sx={{ width: "100%" }}>
            <ToggleButtonGroup
              value={alignment}
              exclusive
              onChange={handleAlignment}
              sx={{
                gap: 2,
                "& .MuiToggleButtonGroup-grouped": {
                  borderRadius: "8px !important",
                },
              }}
            >
              <ToggleButton
                value="fastsmart"
                sx={{
                  width: "100px",
                  height: "60px",
                  borderRadius: "8px",
                  backgroundColor: "#e0e0e0",
                  "&:hover": {
                    backgroundColor: "#e0e0e0",
                  },
                  "&.Mui-selected": {
                    backgroundColor: "#1E88E5",
                    "& .MuiTypography-root": {
                      color: "#fff",
                    },
                    ":hover": {
                      backgroundColor: "#1E88E5",
                    },
                  },
                }}
              >
                <Typography
                  sx={{
                    fontSize: "14px",
                    fontWeight: 500,
                    color: "rgba(96, 96, 96, 1)",
                    textTransform: "none",
                  }}
                >
                  Arch Adjustment
                </Typography>
              </ToggleButton>

              <ToggleButton
                value="finetune"
                sx={{
                  width: "100px",
                  height: "60px",
                  borderRadius: "8px",
                  backgroundColor: "#e0e0e0",
                  "&:hover": {
                    backgroundColor: "#e0e0e0",
                  },
                  "&.Mui-selected": {
                    backgroundColor: "#1E88E5",
                    "& .MuiTypography-root": {
                      color: "#fff",
                    },
                    ":hover": {
                      backgroundColor: "#1E88E5",
                    },
                  },
                }}
              >
                <Typography
                  sx={{
                    fontSize: "14px",
                    fontWeight: 500,
                    color: "rgba(96, 96, 96, 1)",
                    textTransform: "none",
                  }}
                >
                  Vertical Adjustment
                </Typography>
              </ToggleButton>
            </ToggleButtonGroup>
          </Stack>
          <Dialog open={fastsmartAlert}>
            <DialogContent>
              Please select a single arch to use this function.
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => {
                  setFastsmartAlert(false)
                }}
                sx={{
                  textTransform: "uppercase",
                }}
                size="medium"
                variant="contained"
              >
                OK
              </Button>
            </DialogActions>
          </Dialog>
        </>
      }
    />
  )
}
